export const CloverErrorDetailType = {
    JSON_ERROR: 'clover_json_error_details',
    TEXT_ERROR: 'clover_text_error_details',
    HTTP_STATUS_ERROR: 'clover_http_status_error_details',
    NETWORK_ERROR: 'clover_network_error_details',
} as const;

export type CloverErrorDetailType =
    (typeof CloverErrorDetailType)[keyof typeof CloverErrorDetailType];

export interface CloverGatewayErrorObject {
    readonly message?: string;
    readonly code?: string;
    readonly type?: string;
    readonly decline_code?: string;
    readonly [key: string]: unknown;
}

export interface CloverGatewayJsonErrorBody {
    readonly message?: string;
    readonly error?: string | CloverGatewayErrorObject;
    readonly errorMessage?: string;
    readonly error_description?: string;
    readonly code?: string;
    readonly errorCode?: string;
    readonly error_code?: string;
    readonly type?: string;
    readonly requestId?: string;
    readonly request_id?: string;
    readonly requestType?: string;
    readonly [key: string]: unknown;
}

export type CloverErrorDetails =
    | {
          readonly error_detail_type: typeof CloverErrorDetailType.JSON_ERROR;
          readonly operation: string;
          readonly message: string;
          readonly http_status?: number;
          readonly error_code?: string;
          readonly error_type?: string;
          readonly request_id?: string;
          readonly raw_body: CloverGatewayJsonErrorBody;
      }
    | {
          readonly error_detail_type: typeof CloverErrorDetailType.TEXT_ERROR;
          readonly operation: string;
          readonly message: string;
          readonly http_status?: number;
          readonly raw_text: string;
      }
    | {
          readonly error_detail_type: typeof CloverErrorDetailType.HTTP_STATUS_ERROR;
          readonly operation: string;
          readonly message: string;
          readonly http_status: number;
      }
    | {
          readonly error_detail_type: typeof CloverErrorDetailType.NETWORK_ERROR;
          readonly operation: string;
          readonly message: string;
          readonly error_name?: string;
      };
